export default __webpack_public_path__ + "static/media/shutterstock_212968645.b585b6cd.png";